export interface ComicChapter {
  id: string;
  title: string;
  number: number;
  updatedAt: string;
}

export interface Comic {
  id: string;
  title: string;
  author: string;
  coverImage: string;
  description: string;
  category: string;
  categorySlug: string;
  status: '连载中' | '已完结';
  rating: number;
  views: number;
  favorites: number;
  tags: string[];
  updatedAt: string;
  chapters: ComicChapter[];
}

export const comics: Comic[] = [
  {
    id: 'comic-1',
    title: '星辰变',
    author: '我吃西红柿',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20stunning%20Chinese%20manhua%20cover%20art%20featuring%20a%20young%20warrior%20with%20flowing%20black%20hair%20holding%20a%20glowing%20sword%20against%20a%20starry%20night%20sky%20background%2C%20dramatic%20lighting%2C%20vibrant%20colors%2C%20anime%20art%20style%2C%20clean%20composition%2C%20professional%20illustration&width=600&height=800&seq=manga-cover-01&orientation=portrait',
    description: '一名普通少年秦羽，为了获得父亲的认可，踏上了一条充满荆棘的修炼之路。从凡人到强者，从人间到仙界，他凭借坚韧不拔的意志和无与伦比的天赋，一步步走向宇宙之巅。这是一个关于成长、勇气与梦想的史诗故事。',
    category: '热血',
    categorySlug: 'rexue',
    status: '连载中',
    rating: 4.8,
    views: 1280000,
    favorites: 95000,
    tags: ['东方玄幻', '修炼', '热血', '逆袭'],
    updatedAt: '2026-08-09',
    chapters: [
      { id: 'ch-1-1', title: '第一话 星辰之力', number: 1, updatedAt: '2026-01-15' },
      { id: 'ch-1-2', title: '第二话 初入修炼', number: 2, updatedAt: '2026-01-22' },
      { id: 'ch-1-3', title: '第三话 突破瓶颈', number: 3, updatedAt: '2026-02-01' },
      { id: 'ch-1-4', title: '第四话 试炼之路', number: 4, updatedAt: '2026-02-10' },
      { id: 'ch-1-5', title: '第五话 激战魔兽', number: 5, updatedAt: '2026-02-20' },
      { id: 'ch-1-6', title: '第六话 星辰觉醒', number: 6, updatedAt: '2026-03-05' },
      { id: 'ch-1-7', title: '第七话 天劫降临', number: 7, updatedAt: '2026-03-18' },
      { id: 'ch-1-8', title: '第八话 飞升之路', number: 8, updatedAt: '2026-04-02' },
    ],
  },
  {
    id: 'comic-2',
    title: '樱花树下的约定',
    author: '夏小沫',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20beautiful%20romance%20manga%20cover%20featuring%20a%20young%20couple%20standing%20under%20a%20blooming%20cherry%20blossom%20tree%2C%20soft%20pastel%20pink%20tones%2C%20gentle%20spring%20light%2C%20anime%20art%20style%2C%20dreamy%20atmosphere%2C%20emotional%20illustration%2C%20clean%20composition&width=600&height=800&seq=manga-cover-02&orientation=portrait',
    description: '高中生林小雨在樱花盛开的季节遇见了转学生苏晨。两个性格截然不同的人在校园生活中逐渐靠近，青涩的感情在樱花树下悄然萌芽。然而毕业的钟声即将敲响，他们能否守住这份纯真的约定？一部温暖治愈的校园恋爱物语。',
    category: '恋爱',
    categorySlug: 'lianai',
    status: '连载中',
    rating: 4.6,
    views: 980000,
    favorites: 82000,
    tags: ['校园', '青春', '治愈', '初恋'],
    updatedAt: '2026-08-08',
    chapters: [
      { id: 'ch-2-1', title: '第一话 樱花盛开的日子', number: 1, updatedAt: '2026-02-14' },
      { id: 'ch-2-2', title: '第二话 转学生', number: 2, updatedAt: '2026-02-21' },
      { id: 'ch-2-3', title: '第三话 图书馆的秘密', number: 3, updatedAt: '2026-03-01' },
      { id: 'ch-2-4', title: '第四话 夏日祭', number: 4, updatedAt: '2026-03-14' },
      { id: 'ch-2-5', title: '第五话 心动的瞬间', number: 5, updatedAt: '2026-03-28' },
      { id: 'ch-2-6', title: '第六话 雨天', number: 6, updatedAt: '2026-04-10' },
    ],
  },
  {
    id: 'comic-3',
    title: '暗夜追踪者',
    author: '暗影工作室',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20dark%20mystery%20manga%20cover%20featuring%20a%20detective%20in%20a%20trench%20coat%20standing%20in%20a%20rainy%20alley%20at%20night%2C%20neon%20lights%20reflecting%20on%20wet%20pavement%2C%20noir%20atmosphere%2C%20anime%20art%20style%2C%20dramatic%20shadows%2C%20suspenseful%20mood&width=600&height=800&seq=manga-cover-03&orientation=portrait',
    description: '城市中接连发生离奇命案，天才侦探白夜被卷入这场连环案件中。每一个现场都留下了诡异的符号，仿佛在嘲笑警方的无能。随着调查深入，白夜发现这些案件背后隐藏着一个惊天阴谋，而真相远比想象中更加黑暗。',
    category: '悬疑',
    categorySlug: 'xuanyi',
    status: '连载中',
    rating: 4.7,
    views: 750000,
    favorites: 61000,
    tags: ['推理', '都市', '犯罪', '心理'],
    updatedAt: '2026-08-07',
    chapters: [
      { id: 'ch-3-1', title: '第一话 深夜来电', number: 1, updatedAt: '2026-03-01' },
      { id: 'ch-3-2', title: '第二话 第一个现场', number: 2, updatedAt: '2026-03-08' },
      { id: 'ch-3-3', title: '第三话 诡异符号', number: 3, updatedAt: '2026-03-15' },
      { id: 'ch-3-4', title: '第四话 第二位受害者', number: 4, updatedAt: '2026-03-22' },
      { id: 'ch-3-5', title: '第五话 线索浮现', number: 5, updatedAt: '2026-04-01' },
    ],
  },
  {
    id: 'comic-4',
    title: '超能学园',
    author: '喵喵酱',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20funny%20comedy%20manga%20cover%20featuring%20colorful%20school%20students%20with%20exaggerated%20facial%20expressions%20and%20superpowers%2C%20bright%20and%20playful%20colors%2C%20anime%20chibi%20art%20style%2C%20energetic%20composition%2C%20humorous%20illustration%2C%20clean%20simple%20background&width=600&height=800&seq=manga-cover-04&orientation=portrait',
    description: '平凡高中生张小凡意外获得了超能力，被转入一所专门培养超能力者的秘密学园。在这里他遇到了各种各样奇葩的同学：会飞的吃货、力大无穷的萝莉、读心术失败的倒霉蛋。每天都是一场充满笑料的超级闹剧！',
    category: '搞笑',
    categorySlug: 'gaoxiao',
    status: '连载中',
    rating: 4.5,
    views: 620000,
    favorites: 48000,
    tags: ['校园', '超能力', '日常', '爆笑'],
    updatedAt: '2026-08-06',
    chapters: [
      { id: 'ch-4-1', title: '第一话 我居然有超能力？！', number: 1, updatedAt: '2026-04-01' },
      { id: 'ch-4-2', title: '第二话 入学考试', number: 2, updatedAt: '2026-04-08' },
      { id: 'ch-4-3', title: '第三话 我的奇葩室友', number: 3, updatedAt: '2026-04-15' },
      { id: 'ch-4-4', title: '第四话 第一次任务', number: 4, updatedAt: '2026-04-22' },
    ],
  },
  {
    id: 'comic-5',
    title: '异界药师',
    author: '灵药公子',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20fantasy%20manga%20cover%20featuring%20a%20mysterious%20alchemist%20in%20elegant%20robes%20surrounded%20by%20glowing%20potions%20and%20magical%20herbs%2C%20warm%20golden%20light%2C%20anime%20art%20style%2C%20magical%20atmosphere%2C%20detailed%20background%20with%20ancient%20books&width=600&height=800&seq=manga-cover-05&orientation=portrait',
    description: '现代药剂师苏晏因一次意外穿越到异世界，成为了一个落魄小药铺的主人。凭借现代医学知识和对草药的独特理解，他在这个以炼药为尊的世界中脱颖而出。从无人问津到名震大陆，他用一瓶瓶神奇的药剂改变着这个世界的命运。',
    category: '奇幻',
    categorySlug: 'qihuan',
    status: '连载中',
    rating: 4.9,
    views: 1500000,
    favorites: 110000,
    tags: ['异世界', '穿越', '炼药', '逆袭'],
    updatedAt: '2026-08-09',
    chapters: [
      { id: 'ch-5-1', title: '第一话 穿越异界', number: 1, updatedAt: '2026-01-01' },
      { id: 'ch-5-2', title: '第二话 药铺继承人', number: 2, updatedAt: '2026-01-08' },
      { id: 'ch-5-3', title: '第三话 首瓶药剂', number: 3, updatedAt: '2026-01-15' },
      { id: 'ch-5-4', title: '第四话 名声初显', number: 4, updatedAt: '2026-01-22' },
      { id: 'ch-5-5', title: '第五话 药师大赛', number: 5, updatedAt: '2026-02-01' },
      { id: 'ch-5-6', title: '第六话 危机降临', number: 6, updatedAt: '2026-02-10' },
      { id: 'ch-5-7', title: '第七话 绝境逆转', number: 7, updatedAt: '2026-02-20' },
      { id: 'ch-5-8', title: '第八话 名动天下', number: 8, updatedAt: '2026-03-01' },
      { id: 'ch-5-9', title: '第九话 新的旅程', number: 9, updatedAt: '2026-03-15' },
      { id: 'ch-5-10', title: '第十话 远古遗迹', number: 10, updatedAt: '2026-03-28' },
    ],
  },
  {
    id: 'comic-6',
    title: '机甲纪元',
    author: '钢铁意志',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20sci-fi%20mecha%20manga%20cover%20featuring%20a%20giant%20robot%20standing%20in%20a%20futuristic%20city%2C%20glowing%20blue%20energy%20cores%2C%20metallic%20textures%2C%20anime%20art%20style%2C%20dramatic%20perspective%2C%20high%20tech%20atmosphere%2C%20epic%20scale&width=600&height=800&seq=manga-cover-06&orientation=portrait',
    description: '公元2150年，人类文明进入机甲时代。少年驾驶员凌云操控着父辈留下的神秘机甲「破晓者」，在星际战场上书写传奇。当外星势力入侵地球，他必须与伙伴们并肩作战，揭开隐藏在机甲核心中的终极秘密。',
    category: '科幻',
    categorySlug: 'kehuan',
    status: '已完结',
    rating: 4.6,
    views: 890000,
    favorites: 72000,
    tags: ['机甲', '未来', '星际', '战争'],
    updatedAt: '2026-07-15',
    chapters: [
      { id: 'ch-6-1', title: '第一话 觉醒', number: 1, updatedAt: '2026-05-01' },
      { id: 'ch-6-2', title: '第二话 破晓者', number: 2, updatedAt: '2026-05-08' },
      { id: 'ch-6-3', title: '第三话 初次战斗', number: 3, updatedAt: '2026-05-15' },
      { id: 'ch-6-4', title: '第四话 队友集结', number: 4, updatedAt: '2026-05-22' },
      { id: 'ch-6-5', title: '第五话 外星来袭', number: 5, updatedAt: '2026-06-01' },
      { id: 'ch-6-6', title: '第六话 最终决战', number: 6, updatedAt: '2026-06-15' },
      { id: 'ch-6-7', title: '最终话 新的黎明', number: 7, updatedAt: '2026-07-01' },
    ],
  },
  {
    id: 'comic-7',
    title: '无尽迷宫',
    author: '迷宫旅人',
    coverImage: 'https://readdy.ai/api/search-image?query=An%20adventure%20manga%20cover%20featuring%20a%20team%20of%20young%20explorers%20with%20weapons%20entering%20a%20mysterious%20underground%20dungeon%2C%20torch%20light%20illuminating%20ancient%20ruins%2C%20anime%20art%20style%2C%20atmospheric%20lighting%2C%20exciting%20composition&width=600&height=800&seq=manga-cover-07&orientation=portrait',
    description: '传说中的无尽迷宫每隔百年开启一次，里面藏有能实现任何愿望的「祈愿之石」。来自各国的冒险者们组成探索队深入迷宫，却发现在迷宫中死亡并不代表真正的终结。每一次倒下，都会带着记忆从入口重新开始。',
    category: '冒险',
    categorySlug: 'maoxian',
    status: '连载中',
    rating: 4.7,
    views: 1100000,
    favorites: 88000,
    tags: ['迷宫', '冒险', '团队', '奇幻'],
    updatedAt: '2026-08-08',
    chapters: [
      { id: 'ch-7-1', title: '第一话 迷宫开启', number: 1, updatedAt: '2026-03-01' },
      { id: 'ch-7-2', title: '第二话 第一层', number: 2, updatedAt: '2026-03-10' },
      { id: 'ch-7-3', title: '第三话 陷阱重重', number: 3, updatedAt: '2026-03-20' },
      { id: 'ch-7-4', title: '第四话 守护者', number: 4, updatedAt: '2026-04-01' },
      { id: 'ch-7-5', title: '第五话 真相', number: 5, updatedAt: '2026-04-15' },
    ],
  },
  {
    id: 'comic-8',
    title: '猫咪咖啡厅',
    author: '软糖喵',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20heartwarming%20slice%20of%20life%20manga%20cover%20featuring%20cute%20cats%20and%20a%20young%20barista%20in%20a%20cozy%20cat%20cafe%2C%20warm%20sunlight%20through%20windows%2C%20soft%20pastel%20colors%2C%20anime%20art%20style%2C%20peaceful%20atmosphere%2C%20gentle%20composition&width=600&height=800&seq=manga-cover-08&orientation=portrait',
    description: '失业青年陈小喵误打误撞成为了一家猫咪咖啡厅的店员。在这里，每只猫咪都有自己的小脾气和故事，每位客人都带着各自的心事而来。在咖啡的香气和猫咪的陪伴中，人与人之间的温情故事每一天都在上演。',
    category: '日常',
    categorySlug: 'richang',
    status: '连载中',
    rating: 4.4,
    views: 450000,
    favorites: 35000,
    tags: ['治愈', '猫咪', '美食', '日常'],
    updatedAt: '2026-08-05',
    chapters: [
      { id: 'ch-8-1', title: '第一话 第一天上班', number: 1, updatedAt: '2026-05-01' },
      { id: 'ch-8-2', title: '第二话 傲娇的布丁', number: 2, updatedAt: '2026-05-08' },
      { id: 'ch-8-3', title: '第三话 第一位客人', number: 3, updatedAt: '2026-05-15' },
      { id: 'ch-8-4', title: '第四话 雨天的咖啡', number: 4, updatedAt: '2026-05-22' },
    ],
  },
  {
    id: 'comic-9',
    title: '剑道无双',
    author: '剑心墨客',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20martial%20arts%20manga%20cover%20featuring%20a%20swordsman%20in%20traditional%20Chinese%20robes%20performing%20a%20powerful%20sword%20technique%2C%20dramatic%20ink%20wash%20painting%20style%2C%20dynamic%20movement%2C%20anime%20art%20style%2C%20elegant%20composition&width=600&height=800&seq=manga-cover-09&orientation=portrait',
    description: '剑道世家传人叶无尘因家族变故流落江湖，身负血海深仇的他隐姓埋名潜心修炼。十年磨一剑，当他重出江湖之时，天下剑道高手闻之色变。然而复仇之路的尽头，等待他的是更大的真相。',
    category: '热血',
    categorySlug: 'rexue',
    status: '连载中',
    rating: 4.8,
    views: 1350000,
    favorites: 102000,
    tags: ['武侠', '剑道', '复仇', '江湖'],
    updatedAt: '2026-08-09',
    chapters: [
      { id: 'ch-9-1', title: '第一话 灭门', number: 1, updatedAt: '2026-02-01' },
      { id: 'ch-9-2', title: '第二话 隐忍', number: 2, updatedAt: '2026-02-10' },
      { id: 'ch-9-3', title: '第三话 十年', number: 3, updatedAt: '2026-02-20' },
      { id: 'ch-9-4', title: '第四话 出山', number: 4, updatedAt: '2026-03-01' },
      { id: 'ch-9-5', title: '第五话 初战', number: 5, updatedAt: '2026-03-12' },
      { id: 'ch-9-6', title: '第六话 名扬', number: 6, updatedAt: '2026-03-25' },
    ],
  },
  {
    id: 'comic-10',
    title: '恋与制作人',
    author: '星光社',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20romantic%20manga%20cover%20featuring%20a%20beautiful%20young%20woman%20surrounded%20by%20four%20handsome%20men%20in%20a%20modern%20office%20setting%2C%20sophisticated%20style%2C%20anime%20art%20style%2C%20warm%20lighting%2C%20fashionable%20characters&width=600&height=800&seq=manga-cover-10&orientation=portrait',
    description: '新人制作人林可可进入业界顶尖的娱乐公司，负责打造一支全新的偶像团体。四位性格迥异的练习生各有各的才华与故事，在追逐梦想的道路上，爱情也在工作中悄然生长。',
    category: '恋爱',
    categorySlug: 'lianai',
    status: '连载中',
    rating: 4.5,
    views: 720000,
    favorites: 58000,
    tags: ['娱乐圈', '偶像', '职场', '多男主'],
    updatedAt: '2026-08-07',
    chapters: [
      { id: 'ch-10-1', title: '第一话 新人的挑战', number: 1, updatedAt: '2026-04-01' },
      { id: 'ch-10-2', title: '第二话 初见四人', number: 2, updatedAt: '2026-04-08' },
      { id: 'ch-10-3', title: '第三话 第一次排练', number: 3, updatedAt: '2026-04-15' },
      { id: 'ch-10-4', title: '第四话 舞台事故', number: 4, updatedAt: '2026-04-22' },
      { id: 'ch-10-5', title: '第五话 心动的信号', number: 5, updatedAt: '2026-05-01' },
    ],
  },
  {
    id: 'comic-11',
    title: '深渊之下',
    author: '深海恐惧',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20horror%20mystery%20manga%20cover%20featuring%20a%20deep%20sea%20submarine%20approaching%20a%20dark%20underwater%20ruin%2C%20eerie%20glowing%20eyes%20in%20the%20darkness%2C%20anime%20art%20style%2C%20cold%20blue%20tones%2C%20suspenseful%20atmosphere&width=600&height=800&seq=manga-cover-11&orientation=portrait',
    description: '深海科考队在太平洋底发现了一座不应该存在的远古遗迹。当他们深入探索时，诡异的声响、队员的失踪、无法解释的现象接连发生。在这万米深渊之下，某种古老的存在正在苏醒。',
    category: '悬疑',
    categorySlug: 'xuanyi',
    status: '连载中',
    rating: 4.6,
    views: 580000,
    favorites: 44000,
    tags: ['深海', '恐怖', '科考', '未知生物'],
    updatedAt: '2026-08-06',
    chapters: [
      { id: 'ch-11-1', title: '第一话 深海信号', number: 1, updatedAt: '2026-06-01' },
      { id: 'ch-11-2', title: '第二话 下潜', number: 2, updatedAt: '2026-06-10' },
      { id: 'ch-11-3', title: '第三话 遗迹之门', number: 3, updatedAt: '2026-06-20' },
    ],
  },
  {
    id: 'comic-12',
    title: '最强外卖员',
    author: '爆笑工坊',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20hilarious%20comedy%20manga%20cover%20featuring%20a%20delivery%20rider%20with%20supernatural%20speed%20dodging%20traffic%20in%20a%20bustling%20city%2C%20exaggerated%20cartoon%20expressions%2C%20bright%20vibrant%20colors%2C%20anime%20art%20style%2C%20action%20packed%20composition&width=600&height=800&seq=manga-cover-12&orientation=portrait',
    description: '修仙界第一强者渡劫失败，灵魂穿越到现代都市一个普通外卖员身上。曾经的仙尊现在要为了五星好评拼命送外卖？飞剑变成了电动车，法术用来保温餐盒。当修仙大佬遭遇现代职场，笑料百出的生活开始了！',
    category: '搞笑',
    categorySlug: 'gaoxiao',
    status: '连载中',
    rating: 4.7,
    views: 880000,
    favorites: 76000,
    tags: ['穿越', '修仙', '都市', '爆笑'],
    updatedAt: '2026-08-08',
    chapters: [
      { id: 'ch-12-1', title: '第一话 仙尊变外卖员', number: 1, updatedAt: '2026-05-01' },
      { id: 'ch-12-2', title: '第二话 第一单外卖', number: 2, updatedAt: '2026-05-08' },
      { id: 'ch-12-3', title: '第三话 差评危机', number: 3, updatedAt: '2026-05-15' },
      { id: 'ch-12-4', title: '第四话 同行是冤家', number: 4, updatedAt: '2026-05-22' },
      { id: 'ch-12-5', title: '第五话 修仙外卖大赛', number: 5, updatedAt: '2026-06-01' },
    ],
  },
];

export function getComicById(id: string): Comic | undefined {
  return comics.find((c) => c.id === id);
}

export function getComicsByCategory(slug: string): Comic[] {
  return comics.filter((c) => c.categorySlug === slug);
}

export function getHotComics(limit: number = 6): Comic[] {
  return [...comics].sort((a, b) => b.views - a.views).slice(0, limit);
}

export function getLatestComics(limit: number = 8): Comic[] {
  return [...comics].sort((a, b) => new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime()).slice(0, limit);
}

export function getTopRatedComics(limit: number = 6): Comic[] {
  return [...comics].sort((a, b) => b.rating - a.rating).slice(0, limit);
}

export function getRelatedComics(comic: Comic, limit: number = 4): Comic[] {
  return comics.filter((c) => c.id !== comic.id && c.categorySlug === comic.categorySlug).slice(0, limit);
}